import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

// One form field, label above the input, left-aligned.
// When the wrapped react-admin input has its own label, that <label> is the one shown:
// it is tied to the input and carries the required asterisk. The `label` prop is only
// rendered for content without a label of its own (read-only values, colour pickers, uploads).
const FormField = ({
  label,
  hint,
  children,
}: {
  label: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
}) => (
  <Box
    sx={{
      "&:has(.MuiInputLabel-root, .MuiFormLabel-root, .MuiFormControlLabel-root) > .form-field-label": {
        display: "none",
      },
      "& .MuiFormControl-root": { mt: 0, mb: 0 },
      "& .MuiFormHelperText-root": { mx: 0 },
      // The input label leaves its floating position and sits above the field.
      "& .MuiInputLabel-root": {
        position: "static",
        transform: "none",
        maxWidth: "none",
        whiteSpace: "normal",
        mb: 0.75,
        fontSize: 13,
        fontWeight: 600,
        lineHeight: 1.4,
        color: "text.primary",
      },
      "& .MuiInputLabel-root.Mui-focused": { color: "text.primary" },
      "& .MuiInputLabel-root.Mui-error": { color: "error.main" },
      "& .MuiInputLabel-root + .MuiInputBase-root": { mt: 0 },
      "& .MuiOutlinedInput-notchedOutline legend": { maxWidth: "0.01px", "& > span": { display: "none" } },
      "& .MuiFilledInput-root .MuiFilledInput-input, & .MuiFilledInput-root .MuiSelect-select": {
        pt: "11px",
        pb: "11px",
      },
      "& .MuiFormLabel-root:not(.MuiInputLabel-root)": {
        fontSize: 13,
        fontWeight: 600,
        color: "text.primary",
        mb: 0.5,
      },
    }}
  >
    <Typography
      component="div"
      className="form-field-label"
      sx={{ fontSize: 13, fontWeight: 600, color: "text.primary", mb: 0.75 }}
    >
      {label}
    </Typography>
    {children}
    {hint && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontSize: 12 }}>
        {hint}
      </Typography>
    )}
  </Box>
);

export default FormField;
